export function limitNumber(target: number | string, limit: number) {
  const _target = parseInt(target as string);
  if (isNaN(_target) || _target <= limit) return target;

  return `${limit}+`;
}
